import {observer} from "mobx-react"
import {App} from "./App"
import {ScaCreatePage, ScaDetailPage, ScaOverviewPage} from "../page/sca";

const ScaApp = observer(function ScaApp({mode}: {mode: 'overview' | 'create' | 'detail'}) {
    return <App>
        {mode === 'overview' && <ScaOverviewPage />}
        {mode === 'detail' && <ScaDetailPage />}
        {mode === 'create' && <ScaCreatePage />}
    </App>
})

export {
    ScaApp
}
